const signup = {
  invalidToken: 'Ungültiges Einladungstoken. Bitte überprüfen Sie den Link oder fordern Sie eine neue Einladung an.',
  invitationAccepted: 'Einladung erfolgreich angenommen. Willkommen an Bord!',
  unknownError: 'Hoppla! Da ist etwas schiefgelaufen.',
  conflictEmailOrPhone: 'Die Anmelde-E-Mail-Adresse oder Telefonnummer wird bereits von einem anderen Moderator verwendet.',
  signupTitle: 'Treten Sie Ihrem Team bei!',
  submitBtn: 'Jetzt beitreten',
  signupSuccessful: 'Sie haben sich erfolgreich bei Moovex angemeldet!',
  signupFailed: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie michael@moovex.com',
  backToLogin: 'Weiter zur Anmeldung',
  phoneInvalid: 'Die Telefonnummer ist ungültig.',
  firstName: 'Vorname',
  lastName: 'Nachname',
  phone: 'Telefon',
  email: 'E-Mail',
  createPassword: 'Passwort erstellen',
  confirmPassword: 'Passwort bestätigen',
  success: {
    redirectIn: 'You will be redirected in ',
    seconds: ' seconds',
  },
};

export default signup;
